import type {
	FormSubmissionSpamState,
	FormSubmissionStatus,
} from '../models/entity/form-submission.entity';

/**
 * PD-16573 — how the inbox names a submission's status and spam check. One place, so the
 * list's badges, its filters and the detail page say the same thing.
 */
export const FORM_SUBMISSION_STATUS_LABELS: Readonly<
	Record<FormSubmissionStatus, string>
> = {
	new: 'New',
	in_review: 'In review',
	converted: 'Converted',
	linked: 'Linked',
	dismissed: 'Dismissed',
};

export const FORM_SUBMISSION_SPAM_LABELS: Readonly<
	Record<FormSubmissionSpamState, string>
> = {
	clean: 'Passed',
	spam: 'Spam',
	duplicate: 'Duplicate',
	unverified: 'Unverified',
};

/**
 * PD-16862 — the name of a submission downloaded as a PDF: the form, the submission number
 * and, when there is one, the company that applied, so a folder of applications sorts and
 * reads by name. Shared so the server's download and the CRM's saved file agree.
 */
export function formSubmissionPdfFileName(
	formName: string,
	id: number,
	company: string | null | undefined,
): string {
	const slug = (value: string): string =>
		value
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '')
			.slice(0, 60)
			.replace(/-+$/g, '');
	const parts = [slug(formName) || 'form', 'submission', String(id)];
	const companySlug = company != null ? slug(company) : '';
	if (companySlug !== '') {
		parts.push(companySlug);
	}
	return `${parts.join('-')}.pdf`;
}
